import * as React from 'react';
import { Button, UiKitRoot } from '@cian/ui-kit';

type TColoredThemeButtonProps = Omit<React.ComponentProps<typeof Button>, 'theme'> & {
  isDesktop?: boolean;
};

export const ColoredThemeButton: React.FC<TColoredThemeButtonProps> = ({ isDesktop, ...props }) => {
  const deviceType = isDesktop ? 'desktop' : 'phone';

  return (
    <UiKitRoot deviceType={deviceType} theme="colored">
      <Button {...props} theme="fill_primary" />
    </UiKitRoot>
  );
};
